import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CaixaRoutingModule } from './caixa-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CaixaRoutingModule
  ]
})
export class CaixaModule { }
